import { ConsoleAdapterApi } from "@vacancorp/console.adapter.api.vacanservice.com";
import dayjs from "dayjs";

export class V2MigrationStatus {
    public readonly checkedUnixtime: number;
    public readonly isInMigration: boolean;
    public readonly forceUseConsoleV2: boolean;
    public readonly isBeforeMigrationPeriod: boolean;
    public readonly migrationEndUnixtime: number | undefined;

    constructor(checkedUnixtime: number, migrationInformation: ConsoleAdapterApi.ResponseGetMemberV2Migration) {
        this.checkedUnixtime = checkedUnixtime;
        this.isInMigration = migrationInformation.isInMigration;
        this.forceUseConsoleV2 = migrationInformation.forceUseConsoleV2;
        this.isBeforeMigrationPeriod = migrationInformation.isBeforeMigrationPeriod;
        this.migrationEndUnixtime = migrationInformation.migrationEndUnixtime;
    }

    // NOTE: 1時間以内にAPIの情報と同期されているかどうか
    public isCheckedRecently(): boolean {
        const checkThreshold = dayjs().subtract(1, "hour");
        return dayjs.unix(this.checkedUnixtime).isAfter(checkThreshold);
    }

    public isInMigrationPeriod(): boolean {
        return this.isInMigration && !this.forceUseConsoleV2;
    }
}
